module.exports = __webpack_public_path__ + "img/accounting.ff1649df.jpg";